import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { AuthenticationService } from '../services/authentication.service';
import { UserRoles } from '../enum/roles.enum';
import { RolePermissionService } from 'src/app/shared/services/role-permission.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService,
    private authService: AuthenticationService,
    private rolePermissionService: RolePermissionService
  ) {
    super(router, keycloak);
  }

  keycloakInstance = this.keycloak.getKeycloakInstance();

  isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    return new Promise<boolean | UrlTree>(async (resolve, reject) => {
      if (!this.authenticated) {
        await this.keycloak.login({
          redirectUri: window.location.origin + state.url,
        });
        resolve(false);
        return;
      }

      const userRole = this.authService.getRoles();

      try {
        const permissions = await firstValueFrom(
          this.rolePermissionService.userPermissions$
        );
        const dashboard_view = !!permissions['dashboard_view'];
        const url = state.url;

        // For Super Admins (SA)
        if (userRole === 'SA') {
          if (url.startsWith('/admin')) {
            resolve(true);
          } else {
            resolve(this.router.parseUrl('/admin/on-boarding/client'));
          }
          return;
        }

        // For Non-SA users
        if (url === '/user/dashboard2/sales' && !dashboard_view) {
          resolve(this.router.parseUrl('/user/profile'));
        } else {
          resolve(true); // Allow all other /user/** paths
        }
      } catch (error) {
        console.error('Error fetching permissions:', error);
        resolve(false);
      }
    });
  }
}
